export type PreparedSearchTerms = {
  simple: string;
  unquoted?: string;
  jsonEscaped?: string;
};

/**
 * Normalize a user-entered search term into the lower-cased variants the
 * extended-find subsystem matches against. Quoted/JSON-ish source text
 * appears with different escape conventions in different sources, so the
 * counter checks all variants.
 */
export function prepareSearchTerm(term: string): PreparedSearchTerms {
  const lower = term.toLowerCase();
  if (!term.includes('"') && !term.includes(":")) return { simple: lower };
  return {
    simple: lower,
    unquoted: lower.replace(/"/g, ""),
    jsonEscaped: lower.replace(/"/g, '\\"'),
  };
}
